import React, { useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";
import TestQueryParametersForm from "./TestQueryParametersForm";
import Button from "../Button";

export default function EditResultNotificationGroup({ id, clientView }) {
  const [show, setShow] = useState(false);
  const [group, setGroup] = useState(null);

  useEffect(
    () => {
      if (!show) return;
      fetchJson("/result_notifications/test_query_parameters/" + id + ".json", group).then(
        (json) => {
          setGroup(json);
        }
      );
    },
    [id, show]
  );

  const handleGroupSubmit = (group) =>
    post("/result_notifications/test_query_parameters", group)
      .then(
        (json) =>
          (window.location = "/result_notifications/test_query_parameters/" + json.result.id)
      )
      .catch((error) => alert(error));

  const toggle = () => setShow(!show);

  return (
    <div>
      <div style={{ textAlign: "left", marginBottom: 20 }}>
        <Button
          icon="fa-edit"
          small
          title={show ? "Cancel" : "Edit Parameters"}
          onClick={toggle}
        />
      </div>
      {show &&
        group && (
          <div>
            <TestQueryParametersForm
              newGroup={group}
              handleGroupSubmit={handleGroupSubmit}
              clientView={clientView}
            />
          </div>
        )}
    </div>
  );
}
